import { AGE_RANGES, AREAS, COUNTRIES, DIAL_CODES, GENDERS, OUTSIDE_NZ } from "@/lib/content";

const splitMobile = (v = "") => {
  const m = v.match(/^(\+\d{1,4})\s*(.*)$/);
  return m ? [m[1], m[2]] : ["+64", v];
};

const Mobile = ({ form, setForm }) => {
  const [code, num] = splitMobile(form.mobile);
  const update = (c, n) => setForm({ ...form, mobile: n ? `${c} ${n}` : "" });
  return (
    <label className="block">
      <span className="mb-1.5 block text-sm font-medium text-charcoal">Mobile</span>
      <div className="flex gap-2">
        <select className="field !w-[118px] shrink-0 appearance-none" value={code} aria-label="Country code" data-testid="profile-dialcode-select"
          onChange={(e) => update(e.target.value, num)}>
          {DIAL_CODES.map(([c, l]) => <option key={l} value={c}>{l}</option>)}
        </select>
        <input className="field min-w-0" type="tel" required minLength={6} autoComplete="tel-national" value={num} data-testid="profile-mobile-input"
          onChange={(e) => update(code, e.target.value.replace(/[^\d\s-]/g, ""))} placeholder="21 123 4567" />
      </div>
    </label>
  );
};

export const emptyProfile = { first_name: "", last_name: "", preferred_name: "", age_range: "", gender: "", area: "", country: "", mobile: "" };

const Text = ({ label, name, form, setForm, type = "text", ...rest }) => (
  <label className="block">
    <span className="mb-1.5 block text-sm font-medium text-charcoal">{label}</span>
    <input className="field" type={type} required value={form[name] || ""} data-testid={`profile-${name}-input`}
      onChange={(e) => setForm({ ...form, [name]: e.target.value })} {...rest} />
  </label>
);

const Select = ({ label, name, options, form, setForm, ageNote }) => (
  <label className="block">
    <span className="mb-1.5 block text-sm font-medium text-charcoal">{label}</span>
    <select className="field appearance-none" required value={form[name] || ""} data-testid={`profile-${name}-select`}
      onChange={(e) => setForm({ ...form, [name]: e.target.value })}>
      <option value="" disabled>Choose</option>
      {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
    {ageNote && form[name] === "Under 18" && (
      <span className="mt-2 block text-sm text-warn" data-testid="underage-note">AHU is for adults 18 and over. If you continue, nothing will be kept.</span>
    )}
  </label>
);

export const ProfileFields = ({ form, setForm, hideAge = false }) => (
  <div className="grid gap-5 sm:grid-cols-2">
    <Text label="First name" name="first_name" form={form} setForm={setForm} autoComplete="given-name" />
    <Text label="Last name" name="last_name" form={form} setForm={setForm} autoComplete="family-name" />
    <Text label="Preferred name" name="preferred_name" form={form} setForm={setForm} />
    <Mobile form={form} setForm={setForm} />
    {!hideAge && <Select label="Age range" name="age_range" options={AGE_RANGES} form={form} setForm={setForm} ageNote />}
    <Select label="Gender" name="gender" options={GENDERS} form={form} setForm={setForm} />
    <div className="sm:col-span-2"><Select label="Area" name="area" options={AREAS} form={form} setForm={setForm} /></div>
    {form.area === OUTSIDE_NZ && (
      <div className="sm:col-span-2 fade-in"><Select label="Country" name="country" options={COUNTRIES} form={form} setForm={setForm} /></div>
    )}
  </div>
);
